import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { PageHeader } from '../components/PageHeader';
import { useAuth } from '../contexts/AuthContext';
import { ApiError } from '../lib/api';
import { useT, userError } from '../i18n/messages';

export function DetailPage({
  titleKey,
  paramKey,
  load,
  testId,
}: {
  titleKey: string;
  paramKey: string;
  load: (token: string, id: string) => Promise<object>;
  testId: string;
}) {
  const t = useT();
  const { tokens } = useAuth();
  const params = useParams();
  const id = params[paramKey];
  const [state, setState] = useState<{
    status: 'loading' | 'success' | 'error';
    data: object | null;
    error: ApiError | null;
  }>({ status: 'loading', data: null, error: null });

  useEffect(() => {
    let cancelled = false;
    if (!tokens || !id) {
      return;
    }
    setState({ status: 'loading', data: null, error: null });
    load(tokens.access_token, id)
      .then((data) => {
        if (!cancelled) {
          setState({ status: 'success', data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({
            status: 'error',
            data: null,
            error:
              error instanceof ApiError
                ? error
                : new ApiError(String(error), 500, 'request_failed'),
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [id, load, tokens]);

  if (!tokens) {
    return <section className="panel">{t('billing.error.unauthorized')}</section>;
  }

  if (state.status === 'loading') {
    return <section className="panel">{t('billing.resource.loading')}</section>;
  }

  if (state.status === 'error' || !state.data) {
    return <section className="panel">{userError(state.error, t)}</section>;
  }

  return (
    <section className="page" data-testid={testId}>
      <PageHeader title={t(titleKey)} />
      <section className="panel page-panel">
        <pre>{JSON.stringify(state.data, null, 2)}</pre>
      </section>
    </section>
  );
}
